(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.initLocation();
      this.excluded = this.getAttribute('data-excluded');
    }

    // Store browsing: on a store's own collection (data-location) or a page already filtered to a
    // store (?filter.p.vendor=...), collection links keep that store's filter so departments stay
    // on that store. It used to remember the store in a cookie and rewrite every collection link on
    // every later page, so a shopper who once opened "Euclid ReStore" silently saw only Euclid
    // stock everywhere. The cookie is now cleared and nothing carries over between visits.
    initLocation() {
      var store_location = "";
      if (this.dataset.location != undefined && this.dataset.location != "") {
        store_location = this.dataset.location;
      } else {
        const vendorParam = new URLSearchParams(location.search).get("filter.p.vendor");
        if (vendorParam && vendorParam.trim() !== "" && vendorParam !== "All Locations") {
          store_location = vendorParam;
        }
      }
      if (this.getCookie('shopify-location')) this.setCookie('shopify-location', "");
      var allLoc_param = "&filter.p.vendor=All Locations";
      if (store_location) {
        var excluded = (this.getAttribute('data-excluded') || '').split(',');
        var related_col = document.querySelectorAll('a');
        related_col.forEach((col) => {
          var link = col.getAttribute('href');
          // Skip anchors without an href; one of them used to throw here and abort the loop.
          if (!link || !link.includes("collections") || link.includes("filter.p.vendor")) return;
          var hashIndex = link.indexOf('#');
          var url = hashIndex === -1 ? link : link.slice(0, hashIndex);
          var hash = hashIndex === -1 ? '' : link.slice(hashIndex);
          var handle = url.split('?')[0].split('/').pop();
          if (excluded.includes(handle)) return;
          // Use "?" for the first query parameter; appending "&" to a bare path produced
          // URLs like /collections/appliances&filter.p.vendor=... which 404.
          var separator = url.includes('?') ? '&' : '?';
          col.setAttribute('href', url + separator + "filter.p.vendor=" + store_location.replaceAll(" ", "+") + allLoc_param + hash);
        })
      }
  }

  // The store-browsing cookie holds only the store name. It is a first-party session cookie
  // (no expiry date: the old code passed none, which wrote "expires=Invalid Date"), sent only
  // to this site (SameSite=Lax, Secure), and an empty value deletes it instead of keeping a
  // blank cookie.
  setCookie(cname, cvalue) {
    if (!cvalue) {
      document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; Secure";
      return;
    }
    document.cookie = cname + "=" + encodeURIComponent(cvalue) + "; path=/; SameSite=Lax; Secure";
  }
  getCookie(cname) {
      // Decode one cookie at a time: decoding the whole cookie string threw on any malformed
      // cookie set by another script, which stopped the sticky header from starting.
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) == 0) {
          try {
            return decodeURIComponent(c.substring(name.length));
          } catch (e) {
            return "";
          }
        }
      }
      return "";
  }


    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
